import React, { FC } from 'react';
import { Box } from '@mui/material';
import LogoAnimation from '../components/FormComponents/Nordic/LogoAnimation';
// import CompanyLogin from '../components/LoginScreenComponents/CompanyLogin';

const AiExplain: FC = () => {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        textAlign: 'left',
      }}>
      <Box
        sx={{
          height: '100vh',
          width: '100vw',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <Box sx={{ paddingY: '10vh' }}>
          <LogoAnimation />
        </Box>
      </Box>
    </Box>
  );
};

export default AiExplain;
